module.exports = __webpack_public_path__ + "static/media/richard.0599378c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/richard.jpg
// module id = 1755
// module chunks = 147